import React from "react"
import { Link } from "gatsby"
import { getSrc } from "gatsby-plugin-image"
import { useSiteTranslations } from "@hooks/useSiteTranslations"

import * as s from "./BlogPostCard.module.scss"

import Arrow from "@assets/icons/arrow.inline.svg"
import { Cta } from "@components/common/cta/Cta"

export const BlogPostCard = ({ post, featured }) => {
  const imageSrc = getSrc(post?.featuredImage?.node?.localFile)

  const {
    blogTranslations: { blog },
  } = useSiteTranslations()

  return (
    <Link
      to={`/news/${post.categories.nodes[0].slug}/${post.slug}`}
      className={`${s.Post__anchor}`}
    >
      <div
        className={`${s.Post} ${!post.featuredImage && s.Post___noImage} ${
          featured && s.Post___featured
        }`}
        style={
          post.acfPost.mainColor
            ? {
                background: post.acfPost.mainColor,
              }
            : {}
        }
        key={post.slug}
      >
        {post.featuredImage && (
          <div
            className={s.Post__featuredImage}
            key={post.slug}
            role="image"
            aria-label={
              post.featuredImage.node.altText
                ? post.featuredImage.node.altText
                : post.title
            }
            style={{
              background: `url(${imageSrc})`,
            }}
          />
        )}
        <div className={s.Post__meta}>
          <span className={s.Post__subLine}>
            {post.categories && post.categories.nodes[0].name} / {post.date}
          </span>
          <h4
            className={s.Post__title}
            dangerouslySetInnerHTML={{ __html: post.title }}
          />

          {post.acfPost.excerpt && (
            <p className={s.Post__excerpt}>{`${post.acfPost.excerpt}`}</p>
          )}

          {featured && <Cta title={blog.postCardCtaText} />}
        </div>

        {!featured && (
          <div className={s.Post__link}>
            <Arrow />
          </div>
        )}
      </div>
    </Link>
  )
}
